<template>
  <div class="container-check" :style="`paddingTop:${barHeight}px`">
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" @click-left="closeWeb" />
        <!-- <span class="tit-left">{{ $t('lang.wd.phoneNumber') }}</span> -->
        <span class="tit-left">{{ $t('lang.check.tit') }}</span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="check-state">
        <!-- <transition name="fade">  </transition> -->
        <!-- <div class="text" v-if="!flag"> -->
        <img class="check_logo" :src="imgCheckResult" alt="" />
        <div class="text text-checking" v-if="!flag">
          <div>{{ $t('lang.check.checking') }}</div>
          <div class="ball ball1"></div>
          <div class="ball ball2"></div>
          <div class="ball ball3"></div>
        </div>
        <!-- </div> -->
        <div class="text" v-if="flag">
          <template v-if="checkResult">
            <!-- <img src="@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/success_logo.png" alt="" /> -->
            <div class="text-success">{{ $t('lang.check.checkPassed') }}</div>
            <div class="after">{{ $t('lang.check.checkPassedTip') }}</div>
          </template>
          <template v-else>
            <!-- <img src="@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/failure_logo.png" alt="" /> -->
            <div class="text-failure">
              {{ $t('lang.wd.state1') }}
              <div class="after">{{ $t('lang.check.disapprovedTip') }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="left-times">
        {{ $t('lang.check.times') }}:
        <span>{{ remainCheckTimes }}</span>
      </div>
      <ul>
        <li>
          <div class="requirements">
            {{ $t('lang.check.requirements') }}
            <div class="before">{{ $t('lang.check.sevenDays') }}</div>
          </div>
          <div>{{ $t('lang.newInvite.k014') }}</div>
          <div>{{ $t('lang.check.status') }}</div>
        </li>
        <li v-for="item in conditions" :key="item.id">
          <div>{{ item.condition }}</div>
          <div v-if="item.performance == ''">-</div>
          <div v-else>{{ item.performance || 0 }}</div>

          <div class="state-icon">
            <img class="checking_icon" v-if="item.checkResult == 0" src="@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/checking_icon.png" alt="" />
            <img v-if="item.checkResult == 1" src="@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/failure_icon.png" alt="" />
            <img v-if="item.checkResult == 2" src="@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/success_icon.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
    <c-failure :showCheckFailureDia="showCheckFailureDia"></c-failure>
  </div>
</template>

<script>
import { apiWithdrawCheck } from '@/api/withdraw.js'
import CFailure from '@/components/CFailure'

export default {
  components: { CFailure },
  props: {},
  data() {
    let query = this.$route.query
    return {
      price: query.price,
      barHeight: query.statusBarHeight || 38,
      walletType: query.walletType || 0,
      conditions: JSON.parse(query.conditions) || null,
      remainCheckTimes: query.remainCheckTimes || 0,
      withdrawalMethod: query.withdrawalMethod || null,
      icon: query.icon || null,
      // list: [],
      flag: false,
      checkResult: false,
      time1: null,
      time2: null,
      time3: null,
      imgCheckResult: require('@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/checking_logo.png'),
      img2: require('@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/failure_logo.png'),
      img3: require('@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/success_logo.png'),

      sevenDays: this.$t('lang.check.sevenDays'),

      showCheckFailureDia: false //检测失败弹框
    }
  },
  created() {
    this.withdrawCheck()
  },
  mounted() {},
  methods: {
    // Performance 数据
    withdrawCheck() {
      this.flag = false
      apiWithdrawCheck(this.walletType).then((res) => {
        if (res) {
          this.conditions.forEach((item, index) => {
            this.time2 = setTimeout(() => {
              res.conditions.forEach((opt) => {
                if (item.id === opt.id) {
                  item.checkResult = opt.checkResult
                  item.performance = opt.performance
                }
                if (index == res.conditions.length - 1) {
                  this.flag = true
                  this.checkResult = res.checkResult
                  if (this.checkResult == true) {
                    this.imgCheckResult = this.img3
                  } else {
                    this.imgCheckResult = this.img2
                    this.time3 = setTimeout(() => {
                      this.showCheckFailureDia = true
                    }, 3000)
                  }
                  if (res.checkResult == true) {
                    this.time2 = setTimeout(() => {
                      this.replace()
                    }, 2000)
                  }
                }
              })
            }, 1000 * (index + 1))
          })
        }
      })
    },

    // 关闭失败提醒弹框
    closeDia() {
      this.showCheckFailureDia = false
      this.$router.replace({
        path: '/withdrawal',
        query: {
          price: this.price,
          withdrawalMethod: this.withdrawalMethod,
          icon: this.icon
        }
      })
    },

    replace() {
      this.$router.replace({
        path: '/withdrawal',
        query: {
          showDialog: this.checkResult,
          price: this.price,
          withdrawalMethod: this.withdrawalMethod,
          icon: this.icon
        }
      })
    }
  },
  watch: {},
  computed: {},
  destroyed() {
    clearTimeout(this.time1)
    clearTimeout(this.time2)
    clearTimeout(this.time3)
  }
}
</script>
<style lang="scss" scoped vars="{ sevenDays }">
.container-check {
  .main {
    .check-state {
      width: 100%;
      height: 200px;
      margin: 30px auto 40px;
      text-align: center;
      img {
        height: 142px;
      }
      .text {
        width: 100%;
        margin-top: 20px;
        font-size: 16px;
        font-family: Inter, Inter;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
      }
      .text-checking {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        color: #a338fc;
        .ball {
          width: 3px;
          height: 3px;
          margin: 0 0px 3px 3px;
          background-color: #a338fc;
          border-radius: 50%;
          animation: move 1.4s infinite ease-in-out both;
        }
        .ball1 {
          /*设置第一个小球的动画延迟*/
          animation-delay: 0.16s;
        }

        .ball2 {
          /*设置第二个小球的动画延迟*/
          animation-delay: 0.32s;
        }

        .ball3 {
          /*设置第二个小球的动画延迟*/
          animation-delay: 0.48s;
        }
      }
      // .check-result {
      //   width: 100%;
      //   margin-top: 20px;
      //   font-size: 16px;
      //   font-family: Inter, Inter;
      //   font-weight: 500;
      //   line-height: 20px;
      //   text-align: center;
      .text-failure {
        position: relative;
        color: #999999;

        > .after {
          width: 100%;
          position: absolute;
          // content: 'Improve your performance to withdraw.';
          color: #000;
          top: 23px;
          left: 0;
          text-align: center;
          font-size: 12px;
          font-family: Inter, Inter;
          font-weight: 400;
          color: #cccccc;
        }
      }

      .text-success {
        position: relative;
        color: #a338fc;
        > .after {
          width: 100%;
          position: absolute;
          // content: 'Congratulations, ready to withdraw...';
          color: #000;
          top: 23px;
          left: 0;
          text-align: center;
          font-size: 12px;
          font-family: Inter, Inter;
          font-weight: 400;
          color: #cccccc;
        }
      }
      // }
    }
    .left-times {
      width: 100%;
      height: 60px;
      padding-right: 16px;
      text-align: right;
      line-height: 60px;
      background: #f9f9fb;
      font-size: 14px;
      font-family: Inter, Inter;
      font-weight: 400;
      color: #666666;
      > span {
        color: #f32e35;
      }
    }
    ul {
      li {
        display: flex;
        align-items: center;
        height: 48px;
        padding: 0 24px;
        font-size: 12px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #666666;
        border: 1px solid #f9f9fb;
        .state-icon {
          > img {
            width: 16px;
            // transition: all 1s ease;
          }
          .checking_icon {
            animation: rotateCheck 2s infinite linear;
          }
        }
        > div:nth-child(1) {
          flex: 1;
        }
        > div:nth-child(2) {
          width: 81px;
          text-align: center;
          margin-right: 30px;
        }
        > div:nth-child(3) {
          width: 33px;
          text-align: center;
        }
      }
      li:nth-child(1) {
        height: 74px;
        font-size: 13px;
        font-weight: 500;
        color: #333333;
      }
      li {
        .requirements {
          position: relative;
          > .before {
            // content: var(--sevenDays);
            position: absolute;
            top: 20px;
            font-size: 11px;
            font-family: Inter, Inter;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
  }
  @keyframes move {
    /*创建动画*/
    0% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes rotateCheck {
    /*创建动画*/
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
